const fmtDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const parseYmd = (s) => {
  if (!s) return null;
  const [y, m, d] = String(s).split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};

export const PERIOD_OPTIONS = [
  { value: "DAY", label: "Hôm nay" },
  { value: "WEEK", label: "Tuần này" },
  { value: "MONTH", label: "Tháng này" },
  { value: "QUARTER", label: "Quý này" },
  { value: "YEAR", label: "Năm này" },
  { value: "CUSTOM", label: "Tùy chọn" },
];

export const getPeriodLabel = (period) =>
  PERIOD_OPTIONS.find((o) => o.value === period)?.label || "Tháng này";

/** DAY for DAY/WEEK/MONTH; MONTH for QUARTER/YEAR; auto for CUSTOM. */
export const getChartBucket = (period, dateFrom, dateTo) => {
  if (period === "QUARTER" || period === "YEAR") return "MONTH";
  if (period === "CUSTOM") {
    const from = parseYmd(dateFrom);
    const to = parseYmd(dateTo);
    if (!from || !to) return "DAY";
    const days = Math.round((to - from) / 86400000) + 1;
    return days > 62 ? "MONTH" : "DAY";
  }
  return "DAY";
};

export const buildPeriodParams = (period, customFrom = "", customTo = "") => {
  const now = new Date();
  const today = fmtDate(now);

  switch (period) {
    case "DAY":
      return { period: "DAY", dateFrom: today, dateTo: today };
    case "WEEK": {
      const d = new Date(now);
      const day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      const mon = new Date(d.getFullYear(), d.getMonth(), diff);
      const sun = new Date(mon);
      sun.setDate(mon.getDate() + 6);
      return { period: "WEEK", dateFrom: fmtDate(mon), dateTo: fmtDate(sun) };
    }
    case "MONTH": {
      const from = new Date(now.getFullYear(), now.getMonth(), 1);
      const to = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return { period: "MONTH", dateFrom: fmtDate(from), dateTo: fmtDate(to) };
    }
    case "QUARTER": {
      const q = Math.floor(now.getMonth() / 3);
      const from = new Date(now.getFullYear(), q * 3, 1);
      const to = new Date(now.getFullYear(), q * 3 + 3, 0);
      return { period: "QUARTER", dateFrom: fmtDate(from), dateTo: fmtDate(to) };
    }
    case "YEAR":
      return {
        period: "YEAR",
        dateFrom: `${now.getFullYear()}-01-01`,
        dateTo: `${now.getFullYear()}-12-31`,
      };
    case "CUSTOM":
      return {
        period: "CUSTOM",
        dateFrom: customFrom || undefined,
        dateTo: customTo || undefined,
      };
    default:
      return buildPeriodParams("MONTH");
  }
};

/**
 * Previous period of the same length / calendar unit for comparison charts.
 */
export const buildPreviousPeriodParams = (period, dateFrom, dateTo) => {
  const from = parseYmd(dateFrom);
  const to = parseYmd(dateTo);
  if (!from || !to) {
    const cur = buildPeriodParams(period || "MONTH");
    return buildPreviousPeriodParams(cur.period, cur.dateFrom, cur.dateTo);
  }

  switch (period) {
    case "DAY": {
      const prev = new Date(from);
      prev.setDate(prev.getDate() - 1);
      const s = fmtDate(prev);
      return { period: "DAY", dateFrom: s, dateTo: s };
    }
    case "WEEK": {
      const prevFrom = new Date(from);
      prevFrom.setDate(prevFrom.getDate() - 7);
      const prevTo = new Date(to);
      prevTo.setDate(prevTo.getDate() - 7);
      return { period: "WEEK", dateFrom: fmtDate(prevFrom), dateTo: fmtDate(prevTo) };
    }
    case "MONTH": {
      const prevFrom = new Date(from.getFullYear(), from.getMonth() - 1, 1);
      const prevTo = new Date(from.getFullYear(), from.getMonth(), 0);
      return { period: "MONTH", dateFrom: fmtDate(prevFrom), dateTo: fmtDate(prevTo) };
    }
    case "QUARTER": {
      const prevFrom = new Date(from.getFullYear(), from.getMonth() - 3, 1);
      const prevTo = new Date(from.getFullYear(), from.getMonth(), 0);
      return { period: "QUARTER", dateFrom: fmtDate(prevFrom), dateTo: fmtDate(prevTo) };
    }
    case "YEAR": {
      const y = from.getFullYear() - 1;
      return { period: "YEAR", dateFrom: `${y}-01-01`, dateTo: `${y}-12-31` };
    }
    case "CUSTOM":
    default: {
      const days = Math.round((to - from) / 86400000) + 1;
      const prevTo = new Date(from);
      prevTo.setDate(prevTo.getDate() - 1);
      const prevFrom = new Date(prevTo);
      prevFrom.setDate(prevFrom.getDate() - (days - 1));
      return { period: "CUSTOM", dateFrom: fmtDate(prevFrom), dateTo: fmtDate(prevTo) };
    }
  }
};
